import * as Sentry from "@sentry/react";
import { StrictMode, startTransition } from "react";
import { hydrateRoot } from "react-dom/client";
import { HydratedRouter } from "react-router/dom";
import * as SentryConfig from "~/lib/sentry/config";
import { PosthogInit } from "./components/posthog";

Sentry.init({
  dsn: SentryConfig.DSN,
  tracesSampleRate: SentryConfig.TRACES_SAMPLE_RATE,

  enabled: window.PARROT_CONFIG.PARROT_ENV !== "local",
  environment: window.PARROT_CONFIG.PARROT_ENV,

  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration(),
  ],
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,
});

startTransition(() => {
  hydrateRoot(
    document,
    <StrictMode>
      <HydratedRouter />
      <PosthogInit />
    </StrictMode>
  );
});
